import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PopupToBottomSheet from '@/shared-components/popups/components/PopupToBottomSheet';
import Text from '@/shared-components/text/components/Text';

import VirtualList from './virtual-list';

import './index.css';

export default function AddToArtlist({ open, close }) {
  const t = useTranslations('common.shared.artwork_view.add_to_artlist');

  if (!open) {
    return null;
  }

  return (
    <>
      <PopupToBottomSheet 
        open={open} 
        close={close} 
        popupOptions={{ opacity: true }} 
        forcePopup
        className="artwork-view-add-to-artlist__popup"
        onTouchStart={e=>e.stopPropagation()} 
        onTouchEnd={e=>e.stopPropagation()} 
        onWheel={e=>e.stopPropagation()}
      >
        <div className="artwork-view-add-to-artlist__container">
          <div className="artwork-view-add-to-artlist__header">
            <Text className="artwork-view-add-to-artlist__header-text">
              {t('title')}
            </Text>

            <XIcon className="artwork-view-add-to-artlist__close" onClick={close}/>
          </div>

          <VirtualList close={close} open={open}/>
        </div>
      </PopupToBottomSheet>
    </>
  );
}
